var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsnaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 360,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m120 243l94-54 0-109 -94 54 0 109 0 0z",
    fill: "#808285"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m120 254l-103-60 0-119 103-60 103 60 0 119 -103 60z",
    style: {
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 5,
      stroke: "#00aeef"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m214 80l-94-54 -94 54 94 54 94-54z",
    fill: "#00aeef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m26 80l0 109 94 54 0-109 -94-54 0 0z",
    fill: "#58595b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m120 157l47-27 0-23 -47-27 -47 27 0 54 47 27 47-27",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 15,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 300,
    fontSize: "25px",
    fontFamily: "'B Yekan'",
    style: {
      fill: "#292952",
      fontWeight: "bold"
    }
  }, "\u0639\u0636\u0648 \u0627\u062A\u062D\u0627\u062F\u06CC\u0647 \u06A9\u0634\u0648\u0631\u06CC"), /*#__PURE__*/React.createElement("text", {
    x: 8,
    y: 343,
    fontSize: "25px",
    fontFamily: "'B Yekan'",
    style: {
      fill: "#292952",
      fontWeight: "bold"
    }
  }, "\u06A9\u0633\u0628 \u0648 \u06A9\u0627\u0631\u0647\u0627\u06CC \u0645\u062C\u0627\u0632\u06CC"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsnaf);
export default __webpack_public_path__ + "static/media/asnaf.c55cfc26cc1bd5dd47eec5928b2483ce.svg";
export { ForwardRef as ReactComponent };